<div
  class="call-out position-relative d-flex"
  [ngClass]="
    position.includes('bottom') ? 'align-items-end' : 'align-items-start'
  "
  [appStoryblok]="_editable"
>
  <img
    *ngIf="image?.filename"
    [ngSrc]="image.filename"
    fill
    class="w-100 h-100"
    [alt]="'Background image'"
  />
  <div
    class="container position-relative z-1 d-flex"
    [ngClass]="
      position.includes('right')
        ? 'justify-content-end'
        : 'justify-content-start'
    "
  >
    <div
      *ngFor="let blok of blocks"
      class="block"
      [style.backgroundColor]="colour"
    >
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </div>
</div>
